export default __webpack_public_path__ + "static/media/doodle.13900c6f.gif";